<template>
  <div>
    <b-container class="self-assesment">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit.prevent="">
            <b-form-group
              horizontal
              breakpoint="lg"
              :label="$t('label_selfAssessment_general_business_title')"
              label-size="lg"
              label-class="title"
              label-cols-md="3"
            >
              <template-status :status="status" />
              <b-form-group
                id="selfAssessment_general_business_companyName"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_companyName"
              >
                <template slot="label">
                  <!--title-->
                  {{ $t("label_selfAssessment_general_business_companyName") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_companyName_tooltip"
                  />
                </template>
                <b-form-input
                  id="selfAssessment_general_business_companyName"
                  type="text"
                  :value="getCompanyNameInUppercase"
                  required
                  disabled
                />
              </b-form-group>
              <!--Tin-->
              <b-form-group
                id="selfAssessment_general_business_taxIdentificationNumber"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_taxIdentificationNumber"
              >
                <template slot="label">
                  {{
                    $t(
                      "label_selfAssessment_general_business_taxIdentificationNumber"
                    )
                  }}
                </template>
                <b-form-input
                  id="selfAssessment_general_business_taxIdentificationNumber"
                  v-model="
                    selfAssessment_general_business_taxIdentificationNumber
                  "
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentTextInputTin"
                />
              </b-form-group>
              <!--END-->
              <b-form-group
                id="selfAssessment_general_business_entityType"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_entityType"
              >
                <template slot="label">
                  {{ $t("label_selfAssessment_general_business_entityType") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_entityType_tooltip"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_entityType"
                  v-model="selfAssessment_general_business_entityType"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_business_entityType'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_business_organizationType"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_organizationType"
              >
                <template slot="label">
                  {{
                    $t("label_selfAssessment_general_business_organizationType")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_organizationType_tooltip"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_organizationType"
                  v-model="selfAssessment_general_business_organizationType"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_business_organizationType'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_business_locationCountry_id"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_locationCountry_id"
              >
                <template slot="label">
                  {{
                    $t("label_selfAssessment_general_business_locationCountry")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_locationCountry_tooltip"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_locationCountry_id"
                  v-model="selfAssessment_general_business_locationCountry_id"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in countries"
                    :key="itemIndex"
                    :value="item.id"
                    :selected="
                      selfAssessment_general_business_locationCountry_id ===
                      item.id
                    "
                  >
                    {{ $t(item.country) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_business_certificationStatus"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_certificationStatus"
              >
                <template slot="label">
                  {{
                    $t(
                      "label_selfAssessment_general_business_certificationStatus"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_certificationStatus_tooltip"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_certificationStatus"
                  v-model="selfAssessment_general_business_certificationStatus"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_business_certificationStatus'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_business_wepsSignatory"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_wepsSignatory"
              >
                <template slot="label">
                  {{
                    $t("label_selfAssessment_general_business_wepsSignatory")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_wepsSignatory_toolTip"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_wepsSignatory"
                  v-model="selfAssessment_general_business_wepsSignatory"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_business_wepsSignatory'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_business_unGlobalCompactMember"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                label-for="selfAssessment_general_business_unGlobalCompactMember"
              >
                <template slot="label">
                  {{
                    $t(
                      "label_selfAssessment_general_business_unGlobalCompactMember"
                    )
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_general_business_unGlobalCompactMember_toolTIp"
                  />
                </template>
                <b-form-select
                  id="selfAssessment_general_business_unGlobalCompactMember"
                  v-model="
                    selfAssessment_general_business_unGlobalCompactMember
                  "
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateBusiness"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="string" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_business_unGlobalCompactMember'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
            <b-form-group
              horizontal
              breakpoint="lg"
              :label="$t('label_selfAssessment_general_classification_title')"
              label-size="lg"
              label-class="title"
              label-cols-md="3"
            >
              <template-status :status="statusSelfAssessment.assessment" />
              <b-form-group
                id="selfAssessment_general_classification_sector"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                :label="
                  $t('label_selfAssessment_general_classification_sector')
                "
                label-for="selfAssessment_general_classification_sector"
              >
                <b-form-select
                  id="selfAssessment_general_classification_sector"
                  v-model="selfAssessment_general_classification_sector"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentOptions"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_classification_sector'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_classification_activityAggregated"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                :label="
                  $t(
                    'label_selfAssessment_general_classification_activityAggregated'
                  )
                "
                label-for="selfAssessment_general_classification_activityAggregated"
              >
                <b-form-select
                  id="selfAssessment_general_classification_activityAggregated"
                  v-model="
                    selfAssessment_general_classification_activityAggregated
                  "
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentOptions"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_classification_activityAggregated'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_classification_activityDetailed"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                :label="
                  $t(
                    'label_selfAssessment_general_classification_activityDetailed'
                  )
                "
                label-for="selfAssessment_general_classification_activityDetailed"
              >
                <b-form-select
                  id="selfAssessment_general_classification_activityDetailed"
                  v-model="
                    selfAssessment_general_classification_activityDetailed
                  "
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentOptions"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_classification_activityDetailed'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <div id="label_selfAssessment_general_classification_market">
                <div class="form-row align-items-center">
                  <label class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_classification_market")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_classification_market_tooltip"
                    />
                  </label>
                  <div class="col">
                    <label class="custom-control custom-checkbox">
                      <input
                        id="selfAssessment_general_classification_market_international"
                        v-model="
                          selfAssessment_general_classification_market_international
                        "
                        type="checkbox"
                        :true-value="true"
                        :false-value="false"
                        :disabled="!canUpdateSelfAssessment"
                        class="mr-1"
                        @click="updateSelfAssessmentCheckbox"
                      />
                      <span class="custom-control-description">{{
                        $t(
                          "selfAssessment_general_classification_market_international"
                        )
                      }}</span>
                    </label>

                    <label class="custom-control custom-checkbox">
                      <input
                        id="selfAssessment_general_classification_market_national"
                        v-model="
                          selfAssessment_general_classification_market_national
                        "
                        type="checkbox"
                        :true-value="true"
                        :false-value="false"
                        :disabled="!canUpdateSelfAssessment"
                        class="mr-1"
                        @click="updateSelfAssessmentCheckbox"
                      />
                      <span class="custom-control-description">{{
                        $t(
                          "selfAssessment_general_classification_market_national"
                        )
                      }}</span>
                    </label>
                    <label class="custom-control custom-checkbox">
                      <input
                        id="selfAssessment_general_classification_market_local"
                        v-model="
                          selfAssessment_general_classification_market_local
                        "
                        type="checkbox"
                        :true-value="true"
                        :false-value="false"
                        :disabled="!canUpdateSelfAssessment"
                        class="mr-1"
                        @click="updateSelfAssessmentCheckbox"
                      />
                      <span class="custom-control-description">{{
                        $t("selfAssessment_general_classification_market_local")
                      }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
            <b-form-group
              horizontal
              breakpoint="lg"
              :label="$t('label_selfAssessment_general_size_title')"
              label-size="lg"
              label-class="title"
              label-cols-md="3"
            >
              <template-status :status="statusSelfAssessment.assessment" />
              <b-form-group
                id="selfAssessment_general_size_numberEmployees"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                :label="$t('label_selfAssessment_general_size_numberEmployees')"
                label-for="selfAssessment_general_size_numberEmployees"
              >
                <b-form-select
                  id="selfAssessment_general_size_numberEmployees"
                  v-model="selfAssessment_general_size_numberEmployees"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentOptions"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_size_numberEmployees'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="selfAssessment_general_size_revenue"
                horizontal
                label-class="text-sm-right"
                label-cols="5"
                :label="$t('label_selfAssessment_general_size_revenue')"
                label-for="selfAssessment_general_size_revenue"
              >
                <b-form-select
                  id="selfAssessment_general_size_revenue"
                  v-model="selfAssessment_general_size_revenue"
                  class="mb-3"
                  :disabled="!canUpdateSelfAssessment"
                  @change.native="updateSelfAssessmentOptions"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, itemIndex) in getOptionListByName(
                      'optionList_selfAssessment_general_size_revenue'
                    )"
                    :key="itemIndex"
                    :value="item.name"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
            <b-form-group
              horizontal
              breakpoint="lg"
              :label="$t('label_selfAssessment_general_financialReturn_title')"
              label-size="lg"
              label-class="title"
              label-cols-md="3"
            >
              <template-status :status="statusSelfAssessment.assessment" />
              <div
                id="selfAssessment_general_financialReturn_revenue"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_revenue"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_revenue"
                    for="selfAssessment_general_financialReturn_revenue"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_financialReturn_revenue")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_revenue_toolTip"
                    />
                  </label>
                  <div class="col">
                    <form-input-numeric
                      id="selfAssessment_general_financialReturn_revenue"
                      v-model="selfAssessment_general_financialReturn_revenue"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <div
                id="selfAssessment_general_financialReturn_netIncome"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_netIncome"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_netIncome"
                    for="selfAssessment_general_financialReturn_netIncome"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t(
                        "label_selfAssessment_general_financialReturn_netIncome"
                      )
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_netIncome_toolTip"
                    />
                  </label>
                  <div class="col">
                    <form-input-numeric
                      id="selfAssessment_general_financialReturn_netIncome"
                      v-model="selfAssessment_general_financialReturn_netIncome"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <div
                id="selfAssessment_general_financialReturn_ebitda"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_ebitda"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_ebitda"
                    for="selfAssessment_general_financialReturn_ebitda"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_financialReturn_ebitda")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_ebitda_toolTip"
                    />
                  </label>
                  <div class="col">
                    <form-input-numeric
                      id="selfAssessment_general_financialReturn_ebitda"
                      v-model="selfAssessment_general_financialReturn_ebitda"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <div
                id="selfAssessment_general_financialReturn_roe"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_roe"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_roe"
                    for="selfAssessment_general_financialReturn_roe"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_financialReturn_roe")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_roe_toolTip"
                    />
                  </label>
                  <div class="col">
                    <b-form-input
                      id="selfAssessment_general_financialReturn_roe"
                      v-model="selfAssessment_general_financialReturn_roe"
                      type="number"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <div
                id="selfAssessment_general_financialReturn_roic"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_roic"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_roic"
                    for="selfAssessment_general_financialReturn_roic"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_financialReturn_roic")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_roic_toolTip"
                    />
                  </label>
                  <div class="col">
                    <b-form-input
                      id="selfAssessment_general_financialReturn_roic"
                      v-model="selfAssessment_general_financialReturn_roic"
                      type="number"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <div
                id="selfAssessment_general_financialReturn_rois"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_rois"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_rois"
                    for="selfAssessment_general_financialReturn_rois"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t("label_selfAssessment_general_financialReturn_rois")
                    }}
                    <template-tooltip
                      tooltip="label_selfAssessment_general_financialReturn_rois_toolTip"
                    />
                  </label>
                  <div class="col">
                    <b-form-input
                      id="selfAssessment_general_financialReturn_rois"
                      v-model="selfAssessment_general_financialReturn_rois"
                      type="number"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <!--No of Shareholders-->
              <div
                id="selfAssessment_general_financialReturn_noShareholders"
                role="group"
                class="b-form-group form-group"
                aria-labelledby="selfAssessment_general_financialReturn_noShareholders"
              >
                <div class="form-row">
                  <label
                    id="selfAssessment_general_financialReturn_noShareholders"
                    for="selfAssessment_general_financialReturn_noShareholders"
                    class="col-sm-5 col-form-label text-sm-right"
                    >{{
                      $t(
                        "selfAssessment_general_financialReturn_noShareholders"
                      )
                    }}
                    <template-tooltip
                      tooltip="selfAssessment_general_financialReturn_noShareholders_toolTip"
                    />
                  </label>
                  <div class="col">
                    <b-form-input
                      id="selfAssessment_general_financialReturn_noShareholders"
                      v-model="
                        selfAssessment_general_financialReturn_noShareholders
                      "
                      type="number"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      @change.native="updateSelfAssessment"
                    />
                  </div>
                </div>
              </div>
              <!--END-->
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="3">
          <b-button variant="primary" style="margin: 20px 0" to="/self-assessment/staff" block>
            {{ $t("label_selfAssessment_button_continue") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
// import { mapFields } from 'vuex-map-fields'
import { mapGetters, mapMutations } from "vuex";
import { SELF_ASSESSMENT_GENERAL_INFORMATION } from "../../../constants/selfAssessmentGeneralInformation.constants";
import { SELF_ASSESSMENT_GENERAL_BUSINESS_FIELDS } from "../../../constants/SelfAssessmentGeneralBusiness.constants";
import { createHelpers } from "vuex-map-fields";

const { mapFields: mapBusinessFields } = createHelpers({
  getterType: "getBusinessField",
  mutationType: "updateBusinessField",
});
const { mapFields: mapSelfAssessmentFields } = createHelpers({
  getterType: "getSelfAssessmentField",
  mutationType: "updateSelfAssessmentField",
});
export default {
  name: "SelfAssessmentGeneralInformation",
  created: async function () {
    await this.$store.dispatch("COUNTRIES_GET").catch(() => {
    });
    await this.$store.dispatch("SNAPSHOTS_GET").catch(() => {
    });
    await this.$store.dispatch("BUSINESS_GET").catch(() => {
    });
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store.commit("setReloadSelfAssessment", false);
      })
      .catch((err) => {
        console.log(err);
        this.$router.push("/home"); // TODO Handle the error in a better way
      });
  },
  methods: {
    updateSelfAssessmentTextInputTin: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;
      this.$store.dispatch("BUSINESS_UPDATE", data);
    },
    updateBusiness: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;
      if (
        event.target.id === "selfAssessment_general_business_locationCountry_id"
      ) {
        var country = this.countries.filter((el) => {
          return el.id.toLowerCase().indexOf(event.target.value) > -1;
        });
        data["selfAssessment_general_business_locationCountry"] =
          country[0].country;
      }
      this.$store.dispatch("BUSINESS_UPDATE", data);
    },
    updateSelfAssessment: function (event) {
      var data = {};
      data[event.target.id] =
        this.selfAssessment[event.target.id] === ""
          ? null
          : this.selfAssessment[event.target.id];
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSelfAssessmentOptions: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSelfAssessmentCheckbox: function (event) {
      var data = {};
      data[event.target.id] = !this.selfAssessment[event.target.id];
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    ...mapMutations(["setReloadSelfAssessment"]),
  },
  computed: {
    getCompanyNameInUppercase: function () {
      return this.selfAssessment_general_business_companyName.toUpperCase();
    },
    ...mapGetters({
      business: "getBusiness",
      selfAssessment: "getSelfAssessment",
      status: "getBusinessStatus",
      statusSelfAssessment: "getSelfAssessmentStatus",
      optionLists: "getOptionLists",
      getOptionListByName: "getOptionListByName",
      countries: "getCountries",
      canUpdateSelfAssessment: "canUpdateSelfAssessment",
      getReloadSelfAssessment: "getReloadSelfAssessment",
    }),
    ...mapBusinessFields(SELF_ASSESSMENT_GENERAL_BUSINESS_FIELDS),
    ...mapSelfAssessmentFields(SELF_ASSESSMENT_GENERAL_INFORMATION),
  },
};
</script>
